import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";


// Convert clean state to HTML for Quill
const toHtml = (value) => {
  if (Array.isArray(value)) {
    return `<ul>${value.map(item => `<li>${item}</li>`).join("")}</ul>`;
  }
  return `<p>${value}</p>`;
};

// Convert Quill HTML back to clean state
const fromHtml = (html) => {
  const container = document.createElement("div");
  container.innerHTML = html;

  if (container.querySelector("ul, ol")) {
    return Array.from(container.querySelectorAll("li")).map(li => li.textContent.trim());
  }
  return container.textContent.trim();
};


export const TextEditor = ({ initial = "", onChange }) => {
  const [editorValue, setEditorValue] = useState(toHtml(initial));
  useEffect(() => {
    setEditorValue(toHtml(initial));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const quillRef = useRef(null);

  useEffect(() => {
    const editor = quillRef.current?.getEditor();
    if (editor && initial === "") {
      // Apply bullet list formatting at start
      editor.formatLine(0, 1, "list", "bullet");
    }
  }, [initial]);

  const handleChange = (val) => {
    setEditorValue(val);
    onChange(fromHtml(val));
  };

  return (
    <div className="mt-2 [&_.ql-toolbar]:hidden [&_.ql-editor li]:pl-0 sm:[&_.ql-editor]:text-[16px] [&_.ql-editor]:text-[13px] [&_.ql-editor]:leading-6 [&_.ql-editor]:font-[Poppins] ">
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={editorValue}
        onChange={handleChange}
        placeholder="Describe your work experience..."
        modules={{ toolbar: false }}
      />
    </div>
  );
}
